<template>
	<div class="patient-view account">
		<SettingsCard :patient="patient">
		</SettingsCard>
	</div>
</template>

<script>
import PatientView from '..'
import { mapState, mapActions, mapGetters } from 'vuex'

export default {
	name: 'patient-account',
	extends: PatientView
}
</script>

<style>
@import "../style.scss";
</style>
